import ServiceLocator from "../../../global/service-locator";

export default class ShuffleAnimation {
	constructor($root) {
		this.$root = $root;
		this.$shuffle = this.$root.querySelector('.shuffle');
		this.$real = this.$root.querySelector('.shuffle_real');
		this.$fake = this.$root.querySelector('.shuffle_container');
		this.$prior = this.$root.querySelector('.shuffle_fake.-prior');
		this.$first = this.$root.querySelector('.shuffle_fake.-first');
		this.$second = this.$root.querySelector('.shuffle_fake.-second');
		this.$third = this.$root.querySelector('.shuffle_fake.-third');
		this.$back = this.$root.querySelector('.shuffle_fake.-back');
		this.$content = this.$real.querySelectorAll('.shuffle_content');
		this.$active = null;

		this.isInitialized = false;
		this.containerHeight = 0;
		this.animationDuration = 500; // duration of shuffling animation equal to animate-prop in css
		this.totalPages = null;
		this.currentPage = 1;

		this.modalService = ServiceLocator.instance.modalService;
	}

	init(totalPages, pageNum = 1) {
		this.toggleWillChange('add');

		if (!this.isInitialized) {
			this.totalPages = totalPages;
			this.switchShuffleActive(pageNum);
			this.$real.classList.add('-transitioned');
			this.isInitialized = true;

			setTimeout(() => {
				this.updateHeight();
			}, 0);
		}
	}

	switchShuffleActive(pageNum) {
		this.currentPage = pageNum;
		this.$content.forEach(($item) => {
			$item.classList.remove('shuffle-active');
		});
		this.$content[pageNum - 1].classList.add('shuffle-active');
	}

	next(callback) {
		const isMobile = this.checkIfMobile();

		this.hideMain();
		if (callback) callback();
		this.updateHeight();
		if (!isMobile) {
			this.animateNext();
		}
		this.showMain();

		this.modalService.$modalRoot.scrollTop = 0;
	}

	prev(callback) {
		const isMobile = this.checkIfMobile();

		this.hideMain();
		if (callback) callback();
		this.updateHeight();
		if (!isMobile) {
			this.animatePrev();
		}
		this.showMain();

		this.modalService.$modalRoot.scrollTop = 0;
	}

	initial(callback) {
		const isMobile = this.checkIfMobile();

		this.hideMain();
		if (callback) callback();
		this.updateHeight();
		if (!isMobile) {
			this.showFakePages();
		}
		this.showMain();

		this.modalService.$modalRoot.scrollTop = 0;
	}

	toggleWillChange(type) {
		const isMobile = this.checkIfMobile();
		if (isMobile) return;

		if (type === 'add') {
			this.$real.classList.add('-will-change-height');
		} else if (type === 'remove') {
			this.$real.classList.remove('-will-change-height');
		}
	}

	simple(callback) {
		this.hideMain();
		if (callback) callback();
		this.updateHeight();
		this.showMain();

		this.modalService.$modalRoot.scrollTop = 0;
	}

	animateNext() {
		if (this.currentPage > 1 && this.$shuffle.classList.contains('-fake-hidden')) {
			this.showFakePages();
		} else {
			this.shuffleNext();
			this.refreshNext();
		}
		if (this.currentPage === this.totalPages) {
			this.refreshAllAndHideFake();
		}
	}

	animatePrev() {
		if (this.currentPage === 1) {
			this.hideFakePages();
		} else {
			this.shufflePrev();
			this.refreshPrev();
		}
	}

	showFakePages() {
		setTimeout(() => {
			this.$shuffle.classList.remove('-fake-hidden');
		}, this.animationDuration - 100);
	}

	hideFakePages() {
		setTimeout(() => {
			if (!this.$shuffle.classList.contains('-fake-hidden')) {
				this.$shuffle.classList.add('-fake-hidden');
			}
		}, this.animationDuration);
	}

	updateHeight(height = null, animate = true) {
		this.containerHeight = height ? height : this.$real.querySelector('.shuffle-active').offsetHeight;

		if (animate) {
			this.$real.classList.add('-transitioned');
			this.$real.style.height = this.containerHeight + 'px';
		} else {
			this.$real.classList.remove('-transitioned');
			this.$real.style.height = this.containerHeight + 'px';
		}
	}

	hideMain() {
		this.$active = this.$real.querySelector('.shuffle-active');
		this.$real.classList.add('-animate-real');
		this.$active.style.opacity = 0;
	}

	showMain() {
		setTimeout(() => {
			this.$active = this.$real.querySelector('.shuffle-active');
			this.$real.classList.remove('-animate-real');
			this.$active.style.opacity = 1;
		}, this.animationDuration);
	}

	shuffleNext() {
		if (this.currentPage === this.totalPages - 1) {
			this.$fake.classList.add('-pre-last');
		}
		if (this.currentPage === this.totalPages) {
			this.$fake.classList.add('-last');
		}
		this.$first.classList.add('-next-first');
		this.$second.classList.add('-next-second');
		this.$third.classList.add('-next-third');
		this.$back.classList.add('-next-back');
	}

	refreshNext() {
		const promise = new Promise((done) => {
			setTimeout(() => {
				this.$first.classList.remove('-next-first');
				done();
			}, this.animationDuration + 300);
		});
		promise.then(() => {
			if (this.currentPage < this.totalPages) {
				this.$second.classList.remove('-next-second');
			}
		}).then(() => {
			if (this.currentPage < this.totalPages - 1) {
				this.$third.classList.remove('-next-third');
			}
		}).then(() => {
			if (this.currentPage < this.totalPages - 1) {
				this.$back.classList.remove('-next-back');
			}
		});
	}

	shufflePrev() {
		this.$prior.classList.add('-prev-prior');
		this.$first.classList.add('-prev-first');
		this.$second.classList.add('-prev-second');
		this.$third.classList.add('-prev-third');
		this.$back.classList.add('-prev-back');
	}

	refreshPrev() {
		const promise = new Promise((done) => {
			this.$back.classList.remove('-next-back');
			if (this.$third.classList.contains('-next-third')) {
				this.$third.classList.add('-invisible');
				this.$third.classList.remove('-next-third');
			}
			setTimeout(() => {
				this.$prior.classList.remove('-prev-prior');
				this.$third.classList.remove('-invisible');
				done();
			}, this.animationDuration + 300);
		});
		promise.then(() => {
			this.$first.classList.remove('-prev-first');
			this.$second.classList.remove('-prev-second');
			this.$third.classList.remove('-prev-third');
			this.$fake.classList.remove('-pre-last');
			this.$back.classList.remove('-prev-back');
		});
	}

	refreshAllAndHideFake() {
		this.hideFakePages();
		setTimeout(() => {
			this.$second.classList.add('-invisible');
			this.$third.classList.add('-invisible');
			this.$back.classList.add('-invisible');
			this.$fake.classList.add('-invisible');
			this.$fake.classList.add('-invisible');

			this.$second.classList.remove('-next-second', '-invisible');
			this.$third.classList.remove('-next-third', '-invisible');
			this.$back.classList.remove('-next-back', '-invisible');
			this.$fake.classList.remove('-pre-last', '-invisible');
			this.$fake.classList.remove('-last', '-invisible');
		}, this.animationDuration + 300);
	}

	setDefaultState() {
		this.currentPage = this.totalPages - 2;
	}

	setPreLastPageState() {
		this.currentPage = this.totalPages - 1;
	}

	setLastPageState() {
		this.currentPage = this.totalPages;
	}

	checkIfMobile() {
		return window.matchMedia('(max-width: 500px)').matches;
	}
}